import MainLogo from "../../assets/image/jgc_logo.png";
import "../../../src/stylecss/mainpage.css";
import "swiper/css";


const MainPage = () => {
  return (
    <>
      <div className="footer-bg bg-dark text-white py-5">
        <footer className="container text-center">
          <h2 className="mb-4 text-white">Welcome to JAS Jaipur</h2>
          <img
            src={MainLogo}
            className="img-fluid"
            alt="JAS Jaipur Logo"
            style={{ maxWidth: '150px', height: 'auto' }}
          />
        </footer>
      </div>
    </>
  );
};

export default MainPage;